if(Cookies.get('radiofanats_cookie')) {

} else {

  $('.cookies').fadeIn()

  $('body').on('click', '.cookies .decline', function (e){
    e.preventDefault()
    $('.cookies').fadeOut()
  })

  $('body').on('click', '.cookies .accept', function (e){
    e.preventDefault()
    Cookies.set('radiofanats_cookie', '1', { expires: 30 });
    $('.cookies').fadeOut()
  })


}
